import type { MediaAttempt } from './MediaAttemptJournal';
import type { MediaDiagnosticEvent } from './MediaDiagnosticHistory';

const CAPTURE_CONFIRMED_PHASES = new Set([
  'capture_received', 'local_file_ready', 'local_file_failed', 'prepare_started', 'prepared',
  'prepare_failed', 'upload_started', 'storage_uploaded', 'reference_committed', 'upload_failed',
  'source_missing',
]);

/** Ausência de evento não prova ausência de captura; outra tentativa não prova recuperação da mesma foto. */
export const mediaAttemptDiagnosticContext = (
  attempt: MediaAttempt,
  history: readonly MediaDiagnosticEvent[],
  observedAt: number,
) => {
  const sameField = history.filter(event => event.checklistId === attempt.checklistId && event.fieldId === attempt.fieldId);
  const captureConfirmed = CAPTURE_CONFIRMED_PHASES.has(attempt.phase ?? '') || sameField.some(event =>
    event.attemptId === attempt.id && CAPTURE_CONFIRMED_PHASES.has(event.phase));
  const laterReference = sameField.filter(event => event.phase === 'reference_committed' &&
    event.at > attempt.at && event.attemptId && event.attemptId !== attempt.id)
    .sort((a, b) => b.at - a.at)[0];
  return {
    attemptId: attempt.id, checklistId: attempt.checklistId, fieldId: attempt.fieldId,
    source: attempt.source, phase: attempt.phase ?? null, errorCode: attempt.errorCode ?? null,
    captureEvidence: captureConfirmed ? 'confirmed' : 'not_confirmed_in_available_context',
    interruptionContext: attempt.status !== 'interrupted' ? null : captureConfirmed
      ? 'after_capture_confirmation' : 'without_capture_confirmation',
    observedAt: new Date(observedAt).toISOString(),
    laterDifferentAttemptReference: laterReference ? {
      attemptId: laterReference.attemptId!, at: new Date(laterReference.at).toISOString(),
      relationship: 'same_field_not_proof_of_same_media',
    } : null,
  };
};
